<template>
  <form class="form form-loyalty-signup-terms mb-0" @submit.prevent="postTerms">

    <slide-x-left-transition :duration="400" :delay="300">
      <div v-if="show">
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="goTo(urlToLegal)"
                    class="mt-10">Zobacz regulamin</ion-button>
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="goTo(urlToConditions)"
                    class="mt-10">Zobacz ogólne warunki akcji promocyjnej</ion-button>
      </div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="400">
      <hr v-if="show"/>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="500">
      <div v-if="show" v-html="conditionsText" class="mt-10"></div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="600">
      <hr v-if="show"/>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="700">
      <p v-if="show" style="margin-top: 10px">Zaznacz wymagane zgody:</p>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="800">
      <div class="form-group" v-show="show">
        <template v-for="(item,index) in activationAgreements">
          <div class="input-wrapper">
            <!--v-model not working - value is passed as props 'checked'-->
            <ion-checkbox mode="md"
                          :checked="tempAgreements.length > 0 ? tempAgreements[index].isChecked : false"
                          @input="checked = target.value"
                          @ionChange="handleCheckbox($event, index, item.key, $event.target.value)">
            </ion-checkbox>
            <label class="checkbox-label">
              <i class="checkbox-caret" v-if="item.required">*</i>
              <div v-html="item.value"></div>
            </label>
          </div>
          <p class="error"
             v-if="errors['agreements.'+ activationAgreementsGroup +'.'+ item.key]"
             v-text="errors['agreements.'+ activationAgreementsGroup +'.'+ item.key][0]">
          </p>
        </template>
      </div>
    </slide-x-left-transition>

    <slide-y-up-transition :duration="500" :delay="900">
      <div v-if="show">
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="goToStep(1)"
                    class="mt-10">Wstecz
        </ion-button>
        <ion-button mode="ios"
                    size="small"
                    @click="postTerms"
                    class="mt-10">Przejdź dalej
        </ion-button>
      </div>
    </slide-y-up-transition>
  </form>
</template>

<script>
  import { createHelpers } from 'vuex-map-fields';
  import {mapState} from "vuex";
  import goTo from '@/mixins/goto';

  const { mapFields } = createHelpers({
    getterType: `loyalty/getField`,
    mutationType: `loyalty/updateField`,
  });

  export default {
    name: 'LoyaltySignupActivationTerms',
    mixins: [goTo],
    computed: {
      ...mapFields({
        agreements : 'signupActivationForm.agreements'
      }),
      ...mapState({
        errors: state => state.loyalty.errors,
        activations: state => state.loyalty.activations,
        selectedActivation: state => state.loyalty.signupActivationForm.activation,
      }),
      activation(){
        return this.activations.find(x => x.slug === this.selectedActivation)
      },
      activationAgreements(){
        return this.activation.agreements
      },
      activationAgreementsGroup(){
        return this.activation.agreement_group
      },
      conditionsText(){
        return this.activation.conditions_text
      },
      urlToLegal(){
        return this.activation.url_to_legal
      },
      urlToConditions(){
        return this.activation.url_to_conditions
      },
    },
    data() {
      return {
        show: false,
        tempAgreements: [], // helper
      }
    },
    mounted(){
      this.show = true
      this.resetAgreements()
    },
    methods: {
      handleCheckbox(event, i, key, value) {
        const checkbox = event.target
        // prepare agreements
        let obj = {
          [key]: value == "on" ? true : false
        }
        // checkbox is set true
        if (checkbox.checked) {
          this.tempAgreements[i].isChecked = true
          // assign agreements to group
          Object.assign(this.agreements[this.activationAgreementsGroup], obj)
        }
        // checkbox is set false
        else {
          this.tempAgreements[i].isChecked = false
          // Object.assign(this.agreements[this.activationAgreementsGroup], obj)
          this.$set(this.agreements[this.activationAgreementsGroup], key, false)
        }
      },
      resetAgreements(){
        // copy global agreements to local halper and unbind two-way
        this.tempAgreements = _.cloneDeep(this.activationAgreements)
        // clear agreements groups
        this.agreements = {}
        // create agreement group
        this.agreements[this.activationAgreementsGroup] = {} // non-reactive - use $set() to change
        // set all agreements to false (requested)
        this.tempAgreements.forEach((item) => {
          let obj = { [item.key]: false }
          Object.assign(this.agreements[this.activationAgreementsGroup], obj)
        })
      },
      goToStep(step){
        this.$store.commit('loyalty/LOYALTY_SET_SIGNUP_ACTIVATION_CURRENT_STEP', step)
      },
      postTerms(){
        this.$store.dispatch('loyalty/LOYALTY_CONTRACT_ACTIVATION_STORE_REQUEST', 3)
      }
    }
  }
</script>